export default {
  data() {
    return {
      timer: null,
      timeStr: {
        d: '日',
        h: '時間',
        m: '分',
        s: '秒',
      },
      isFinishing: false,
      isFinished: true,
      finishTimeout: null,
    };
  },
  computed: {
    secondsLeft() {
      return this.auction ? this.auction.secondsLeft || 0 : 0;
    },
    timeFinish() {
      return this.auction.timeFinish;
    },
    timeLeft() {
      const seconds = this.secondsLeft;
      const d = Math.floor(seconds / 86400);
      const h = Math.floor((seconds % 86400) / 3600);
      const m = Math.floor((seconds % 3600) / 60);
      const s = seconds % 60;

      return {
        d,
        h: h || d ? this.pad(h) : '',
        m: this.pad(m),
        s: this.pad(s),
      };
    },
    countdown() {
      const d = this.timeLeft.d ? `${this.timeLeft.d}${this.timeStr.d} ` : '';
      const h = this.timeLeft.h ? `${this.timeLeft.h}:` : '';

      return `${d}${h}${this.timeLeft.m}:${this.timeLeft.s}`;
    },
  },
  watch: {
    secondsLeft(newVal, oldVal) {
      if (newVal <= 0) {
        if (oldVal <= 0) return;
        this.finishTimeout = setTimeout(() => this.markAsFinished(), 1000);
      } else if (newVal <= 15) {
        clearTimeout(this.finishTimeout);
        if (oldVal <= 15 && oldVal > 0) return;
        this.isFinished = false;
        this.isFinishing = true;
      } else {
        clearTimeout(this.finishTimeout);
        if (oldVal > 15) return;
        this.isFinished = false;
        this.isFinishing = false;
      }
    },
  },
  methods: {
    markAsFinished() {
      this.isFinishing = false;
      this.isFinished = true;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/mixins/AuctionMixin.js